"use strict";
/**
 * 定义全局eventbus事件
 */
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalEvents;
(function (GlobalEvents) {
    // 页面滚动到底部事件，一般用于滚动底部加载更多
    GlobalEvents["PAGE_SCROLL_END"] = "pageScrollEnd";
})(GlobalEvents || (GlobalEvents = {}));
exports.default = GlobalEvents;
